import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { useCallback, useMemo } from 'react';
import queryString from 'query-string';
import { getWindow } from '../../../system/util/globals';
import { consoleWarn } from '../../../system/util/consoleWarn';
import { isFilterValueEmpty } from '../utils/isFilterValueEmpty';
var win = getWindow();
export var useFilterURLStorage = function useFilterURLStorage(filterId) {
  var setValue = useCallback(function (newValue) {
    if (!win) {
      return;
    }

    if (!filterId) {
      consoleWarn('You should submit the filterId parameter');
      return;
    }

    var location = win.location;
    var serializedQuery = '';

    if (isFilterValueEmpty(newValue)) {
      serializedQuery = queryString.exclude("?".concat(location.search), [filterId]);
    } else {
      serializedQuery = queryString.stringifyUrl({
        url: "?".concat(location.search),
        query: _defineProperty({}, filterId, JSON.stringify(newValue))
      });
    }

    win.history.replaceState({}, '', serializedQuery || '?');
  }, [win, filterId]);
  var initialValue = useMemo(function () {
    if (!win) {
      return undefined;
    }

    var result;
    var parsedQuery = queryString.parseUrl(win.location.href).query;

    try {
      var serializedValue = parsedQuery[filterId];

      if (serializedValue) {
        result = JSON.parse(serializedValue);
      }
    } catch (error) {}

    return result;
  }, [win]);
  return [initialValue, setValue];
};